import { React, useState } from "react";
import * as api from '../../api';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const PasswordReset = () => {

    const { i18n } = useTranslation('common');
    const navigate = useNavigate();
    const [email, setemail] = useState('');
    const [statusMessage, setstatusMessage] = useState('');
    const [successMessage, setsuccessMessage] = useState('');

    const validateEmail = (email) => {
        return true;
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };

    async function handleSubmit(e) {
        // console.log("request reset password");
        e.preventDefault();

        const form = e.target;
        const credentials = {
            email: email.toLowerCase().trim()
        }

        if (email.toLowerCase()) {

            if(validateEmail(email.toLowerCase())){
                api.ResetPassword(credentials).then(res => {
                    // console.log(res);
                    if (res.data === "OK") {
                        setsuccessMessage(i18n.language === "fr" ? "Merci. Vous allez recevoir un email contenant un lien pour réinitialiser votre mot de passe." : "Thank you. You will receive an email containing a link to reset yout password");
                        setstatusMessage('');
                        document.getElementById("emailInput").value = '';
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
            else{
                setstatusMessage(i18n.language === "fr" ? "Email invalide." : "Email invalid.");
                setsuccessMessage('');
            }
        }
    }

    return (
        <div className="Login" >
            <br/>
            <h1>{i18n.language === "fr" ? "Réinitialisation du mot de passe" : "Password reset"}</h1>
            <br/>
            <button onClick={() => navigate('/')}>← {i18n.language === "fr" ? "Retour" : "Back"}</button><br/>
            <br/>
            <br/>
            <form onSubmit={event => handleSubmit(event)}>
                <label>
                    {i18n.language === "fr" ? "Email:" : "Email:"}
                    <input type="text" id="emailInput" onChange={event => setemail(event.target.value)} />
                </label>
                <div className="centered">
                <p style={{ color: "red" }}>{statusMessage}</p>
                <p style={{ color: "green" }}>{successMessage}</p>
                <br/>
                <br/>
               
                <input type="submit" value={i18n.language === "fr" ? "Réinitialiser le mot de passe" : "Reset password"} />
                </div>
            </form>
        </div>
    );
};

export default PasswordReset;